import { CalendarDays, ClipboardEdit, History, PlusCircle, Layers } from 'lucide-react';

import styled from 'styled-components';

import {
    PageActions,
    PageActionsMenu,
    PageBreadcrumb,
    PageBreadcrumbSegment,
    PageHeader,
    type PageActionGroup,
} from 'components/PageHeader';
import { StocksList } from './components/StocksList';
import { TotadminPermission } from 'data/__generated__';

export const Stocks = () => {
    const actionGroups: PageActionGroup[] = [
        {
            label: 'Stocks',
            items: [
                {
                    label: 'Variations de stock à venir',
                    icon: <History />,
                    to: '/stock-variation/future-stock-variations',
                },
                {
                    label: 'Variations par jour',
                    icon: <CalendarDays />,
                    to: '/stock-variations-by-day',
                },
                {
                    label: 'Inventorier un produit',
                    icon: <ClipboardEdit />,
                    to: '/site-inventory-stock/create',
                    requiredPermissions: [TotadminPermission.SiteInventoriesManage],
                },
                {
                    label: 'Créer une variation de stock',
                    icon: <PlusCircle />,
                    to: '/stock-variation/create',
                    requiredPermissions: [TotadminPermission.StockVariationsManage],
                },
                {
                    label: 'Créer plusieurs variations de stock',
                    icon: <Layers />,
                    to: '/stock-variation/create/multi',
                    requiredPermissions: [TotadminPermission.StockVariationsManage],
                },
            ],
        },
    ];

    return (
        <Container>
            <PageHeader>
                <PageBreadcrumb>
                    <PageBreadcrumbSegment kicker="Vue" label="Stocks" isCurrent />
                </PageBreadcrumb>
                <PageActions>
                    <PageActionsMenu groups={actionGroups} />
                </PageActions>
            </PageHeader>
            <Content>
                <ListContainer>
                    <StocksList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
